import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

const EXTERNAL_LINK_API_ROOT = `${apiCoreEndpoint}/external/link`;

export const getExternalLinkService = (
  request: t.GetExternalLinkRequestType
) => {
  log.info("getExternalLinkService Request: " + JSON.stringify(request));
  let GET_CONFIG_API_ENDPOINT = `${EXTERNAL_LINK_API_ROOT}/${request.id}/`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_CONFIG_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_CONFIG_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getExternalLinksService = (
  request?: t.GetExternalLinksRequestType
) => {
  log.info("getExternalLinksService Request: " + JSON.stringify(request));
  const GET_EXTERNAL_LINKS_API_ENDPOINT = EXTERNAL_LINK_API_ROOT;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_EXTERNAL_LINKS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_EXTERNAL_LINKS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const addExternalLinkService = (
  request: t.CreateExternalLinkRequestType
) => {
  log.info("addExternalLinkService Request: " + JSON.stringify(request));
  const ADD_CONFIG_KEY_API_ENDPOINT = EXTERNAL_LINK_API_ROOT;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(ADD_CONFIG_KEY_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, ADD_CONFIG_KEY_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const modifyExternalLinkService = (
  request: t.ModifyExternalLinkRequestType
) => {
  log.info("modifyExternalLinkService Request: " + JSON.stringify(request));
  const MODIFY_CONFIG_KEY_API_ENDPOINT = `${EXTERNAL_LINK_API_ROOT}/${request.id}/`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(MODIFY_CONFIG_KEY_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, MODIFY_CONFIG_KEY_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteExternalLinkService = (
  request: t.DeleteExternalLinkRequestType
) => {
  log.info("deleteExternalLinkService Request: " + JSON.stringify(request));
  const DELETE_CONFIG_KEY_API_ENDPOINT = `${EXTERNAL_LINK_API_ROOT}/${request.id}/`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_CONFIG_KEY_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DELETE_CONFIG_KEY_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
